import m from "../../geodata/es2015/bahrainLow";
window.am4geodata_bahrainLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/bahrainLow.js
// module id = null
// module chunks = 